import { apiRequest } from '../index';
import { OCR_URL } from '../urls';

export const parseImage = (imageKey: any) => {
  return apiRequest('GET', `${OCR_URL}/${imageKey}`, null, null);
};
